import React, { useState } from 'react';
import './verificationOtp.scss'

const VerificationOtp = () => {

    const [otp, setOtp] = useState(['', '', '', '', '', '']);

    const handleOtpChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
    };

    return (
        <div className="otp-verification-container">
            <div className="email-section">
                <input
                    type="email"
                    placeholder="Enter your email"
                />
                <button>Send OTP</button>
            </div>

            <div className="otp-section">
                <div className='otp-cont'>
                {otp.map((digit, index) => (
                    <input
                        key={index}
                        type="text"
                        placeholder="0"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                    />
                ))}
                </div>
                <button>Submit</button>
                <a href="#">
                    Resend OTP
                </a>
            </div>
        </div>
    )
}

export default VerificationOtp